import { newsEventApi } from '../../api/newsEvents';
import { createContentSlice } from './contentSlice';

const { slice, actions } = createContentSlice({
  name: 'newsEvents',
  api: newsEventApi,
  hasPublish: true,
});

export const newsEventReducer = slice.reducer;
export const newsEventActions = actions;

export const selectNewsEvents = (state) => state.newsEvents.items;
export const selectNewsEventsStatus = (state) => state.newsEvents.status;
